
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.5 11.375h-9A.378.378 0 011.125 11c0-.205.17-.375.375-.375h9c.205 0 .375.17.375.375s-.17.375-.375.375zM2.8 4.19H2c-.275 0-.5.225-.5.5V9c0 .275.225.5.5.5h.8c.275 0 .5-.225.5-.5V4.69c0-.28-.225-.5-.5-.5zM6.4 2.595h-.8c-.275 0-.5.225-.5.5V9c0 .275.225.5.5.5h.8c.275 0 .5-.225.5-.5V3.095c0-.275-.225-.5-.5-.5zM10 1h-.8c-.275 0-.5.225-.5.5V9c0 .275.225.5.5.5h.8c.275 0 .5-.225.5-.5V1.5c0-.275-.225-.5-.5-.5z","fill":"#58697D"}})])
          )
        }
      }
    